<template>
    <!-- https://www.highcharts.com/demo/error-bar for reference -->
    <div>
        <highcharts :options="chartOptions"></highcharts>
    </div>
</template>

<script>
import {Chart} from 'highcharts-vue'
import Highcharts from 'highcharts'
import highchartsMore from 'highcharts/highcharts-more'

highchartsMore(Highcharts) // needed for error bars

export default {
        mixins: [],
        components: {
        highcharts: Chart,
    },
    props: {
        chartSeriesArray: Array,
    },
data() {
    return {
        buttonsPressed: {
            bar: true,
        },
        chartOptions: {
            chart: {
                // backgroundColor: {},
                inverted: false,
                type: 'scatter',
                // zoomType: 'xy'
            },
            credits: {
                enabled: false, // remove the "Highcharts.com" credit in the corner of the graph.
            },
            title: {
                // text: // determined by initChart() = this.chartSeriesArray[0][0][0] "Dataset ID"
            },
            // caption: {
            //     text: 'Chart Caption'
            // },
            // xAxis: [{
            //     gridLineWidth: 1, // vertical grid lines
            //     gridLineColor: '#BBB',
            //     // categories: null, 
            //     title: {
            //         //text: // determined by initChart() = this.chartSeriesArray[0][0][7] + 
            //         // ' ('+ this.chartSeriesArray[0][0][9] + ')' "X Axis Name + ' ('+ X Axis Unit + ')',
            //         style: {
            //             color: '#555' // Color of X-axis label
            //         }
            //     }
            // }],
            xAxis: [{
                type: "datetime",
                title: {
                    text: "X AXIS TITLE",
                },
                labels: {
                    formatter: function() {
                        return Highcharts.dateFormat('%b/%e/%Y', this.value);
                    }
                    // format: '{value:%Y-%b-%e}'
                }

            }],
            yAxis: [{ // Primary yAxis
                gridLineColor: '#BBB',
                labels: {
                    format: '{value}',
                    style: {
                        color: '#555' // Color of the Y-axis NUMERICAL labels
                    }
                },
                title: {
                    // text: "Y AXIS TITLE",
                    style: {
                        color: '#555' // Color of the Y-axis TEXT labels
                    }
                }
            }],
            tooltip: {
                formatter: function () {
                    let dateString = new Date(this.x);
                    return 'Date: <b>' + Highcharts.dateFormat('%b/%e/%Y', dateString) +
                        '</b><br>Collections: <b>' + this.y + '</b>';
                },
                // shared: true
            },
            legend: {
                enabled: true
            },
            series: []
        },
    }
},
computed: {},
created: function() {
    this.initchart();
},
mounted: function() {},
methods: {
    initchart() {
        // Data (chartSeriesArray) comes in as an dictionary keyed by date. Each value lists the number of collections
        // done on each date
        const that = this;
        // Set chart title
        this.chartOptions.title.text = "Collections by Date";
        // Set X axis title
        this.chartOptions.xAxis[0].title.text = "Date";
        // Set Y axis title
        this.chartOptions.yAxis[0].title.text = "Number of Collections";
        // push the series' XY data into the chartOptions
        that.chartOptions.series[0] = new Object();
        that.chartOptions.series[0].name = "Collections by Date";
        that.chartOptions.series[0].data = that.sortSeriesArray(this.chartSeriesArray); // sort the series by X coord and then Y coord
        that.chartOptions.series[0].marker = new Object();
        that.chartOptions.series[0].marker.symbol = 'circle';
        that.chartOptions.series[0].marker.enabled = true;
    },
    sortSeriesArray(arr) {
        // sort coordinates by X ascending and then Y ascending
        var sortedArray = arr.sort(function(a, b) {
            if (a[7] == b[7]) {
                return a[2] - b[2];
            }
            return a[7] - b[7];
        });
        return sortedArray;
    },
  }
};
</script>
<style>
</style>
